import classNames from "classnames";
import { type ElementType, forwardRef, type PropsWithChildren } from "react";

import styles from "./BottomBarItem.module.css";

type BottomBarItemProps<C extends ElementType> = PropsWithChildren<{
    as?: C;
    active?: boolean;
    children?: React.ReactNode;
}>;

function BottomBarItemInner<C extends ElementType = "button">(
    {
        as,
        children,
        active,
        className,
        ...otherProps
    }: BottomBarItemProps<C> & Omit<React.ComponentPropsWithoutRef<C>, keyof BottomBarItemProps<C>>,
    ref,
) {
    const Component = as || "button";
    return (
        <Component
            className={classNames(
                styles.bottomBarItem,
                {
                    [styles.active]: active,
                },
                className,
            )}
            {...otherProps}
            ref={ref}
        >
            {children}
        </Component>
    );
}

export const BottomBarItem = forwardRef(BottomBarItemInner);
